import React, { useState } from 'react'
import Modal from '../../../../common/modal'
import { connect } from 'react-redux'
import { updateModal } from '../../../../../store/common/common_action'
import { Button, Stack } from '@mui/material'
import { Item } from '../../../../common/snippets'
import LineInputV3 from '../../../../common/lineInputV3'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import CorporateRateMatrixNew from '../CorporateRateMatrix/CorporateRateMatrixNew'

const ConfirmationModal = (props) => {
    const {dataValues} = props
    const {updateModal, headerText, filters, saveRedirection } = dataValues
    const [showCorpRateMatrix, setShowCorpRateMatrix] = useState(false)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

  return (<>
    <Modal
    headTxt={headerText}
    width={'34%'}
    updateModal={updateModal}
    closeId={"closeButton"}
    modalClass={'booking-popup'}
    modalStyle={modalStyle}
>
    <Stack style={{ display: 'flex', flexDirection: 'column',gap: '16px', justifyContent: 'center' }}>
        <div style={{ fontFamily: 'Roboto', padding:'15px 15px 0px 15px', fontSize: '16px', fontWeight: '500', textAlign: 'left', color: '#444444' }}>
        Do you want to Update Corporate Rates for Selected Party?
        </div>
        <Stack className='itemButtons' style={{ width: '100%', display: 'flex', flexDirection:'row', justifyContent: 'flex-end', borderTop:'1px solid rgba(221, 221, 221, 1)', padding:'12px', gap:'5px' }}>
            <Button
              variant="outlined"
              id={'new_add_btn'}
              sx={{  }}
              className="receiveitembtn"
              // onKeyDown={(e) => navigation1(e, `editBtn-0`, `editBtn-${filteredData?.length - 1}`)}
              onClick={() => {
                updateModal()
              }}
            >
            No
            </Button>
            <Button
              id="abtAddBtn"
              style={{ margin: '0px 0px 0px 5px', height: "40px" }}
              className="btn add-btn"
              variant="contained"
              color="error"
            onClick={() => {saveRedirection()}}
            // onKeyDown={(e) => {
            //     navigation1(e, 'abtCancelBtn', 'abtStatus');
            // }}
            >
              Yes
            </Button>
          </Stack>
       
    </Stack>
</Modal>
{showCorpRateMatrix && <CorporateRateMatrixNew filters={filters} />}
</>
  )
}

export default ConfirmationModal
